import Immutable from 'immutable';

import { ActionTypes } from './actions';
// import { eRPEquipmentMappingOperationData } from '../../../views/management/operations/selectors';

export const initialState = Immutable.fromJS({});

const setERPEquipmentMapppingOperations = (state, { erpEquipmentMapppingOperationData }) => {
  if (!erpEquipmentMapppingOperationData) return state;
  return state.merge({ erpEquipmentMapppingOperationData });
};

const setERPEquipmentMapppingOperationLoaderStatus = (state, { erpEquipmentMappingOperationsLoaderStatus }) => {
  return state.merge({ erpEquipmentMappingOperationsLoaderStatus });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ERP_EQUIPMENT_MAPPING_OPERATION,
    actionFunction: setERPEquipmentMapppingOperations,
  },
  {
    actionType: ActionTypes.SET_ERP_EQUIPMENT_MAPPING_OPERATION_LOADER_STATUS,
    actionFunction: setERPEquipmentMapppingOperationLoaderStatus,
  },
];
